import { render, staticRenderFns } from "./administration.vue?vue&type=template&id=66bfbd0d&scoped=true"
import script from "./administration.vue?vue&type=script&lang=js"
export * from "./administration.vue?vue&type=script&lang=js"
import style0 from "./administration.vue?vue&type=style&index=0&id=66bfbd0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bfbd0d",
  null
  
)

export default component.exports